import { Model } from "./model";

export class MerchantDetails extends Model {
	private code: string = "";
	private country_iso: string = "";
	private city: string = "";
	private street: string = "";
	private location: string = "";

	public getCode(): string {
		return this.code;
	}

	public setCode(s: string): void {
		this.code = s;
	}

	public getCountryIso(): string {
		return this.country_iso;
	}

	public setCountryIso(s: string): void {
		this.country_iso = s;
	}

	public getCity(): string {
		return this.city;
	}

	public setCity(s: string): void {
		this.city = s;
	}

	public getStreet(): string {
		return this.street;
	}

	public setStreet(s: string): void {
		this.street = s;
	}

	public getLocation(): string {
		return this.location;
	}

	public setLocation(s: string): void {
		this.location = s;
	}
}
